/** Web storage that never throws (private mode, blocked storage). Keys live in constants/storage. */
const safe = (area: () => Storage) => ({
  get<T>(k: string, fallback: T): T {
    try {
      const v = area().getItem(k);
      return v === null ? fallback : (JSON.parse(v) as T);
    } catch {
      return fallback;
    }
  },
  set(k: string, v: unknown) {
    try {
      area().setItem(k, JSON.stringify(v));
    } catch {
      /* storage unavailable: convenience only */
    }
  },
  remove(k: string) {
    try {
      area().removeItem(k);
    } catch {
      /* storage unavailable: nothing to remove */
    }
  },
});

/** localStorage: per device, kept across visits. */
export const store = safe(() => window.localStorage);
/** sessionStorage: this tab only, gone when it closes (a choice that must survive a reload, not a visit). */
export const sessionStore = safe(() => window.sessionStorage);
